/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Routes from './../Routes';
import { transFetchData, constraintsFetchData } from './../actions/AppActions'

class Wrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goAhead: false
        };
    }


    componentWillMount() {
        //call gtm tag 
        if (window.OptanonActiveGroups && window.OnetrustActiveGroups) {
            pushOptanonEvents();

            // Send OneTrust events
            function pushOptanonEvents() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(
                    { event: 'OptanonLoaded', "OptanonActiveGroups": OptanonActiveGroups },
                    { event: 'OneTrustLoaded', "OnetrustActiveGroups": OnetrustActiveGroups });
            }
        }

        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push(
                { 'gtm.start': new Date().getTime(), event: 'gtm.js' }
            ); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-WJFPBRR');


    }

    componentDidMount() {

        const transPromise = this.props.transFetchData();
        const constraintPromise = this.props.constraintsFetchData();
        Promise.all([transPromise, constraintPromise]).then(() => {
            this.setState({ goAhead: true });
        }).catch(reason => {
        });
        // if ($("#wrapfabtest").width() > 0) {
        //     window.adsLoaded = true
        // } else {
        //     window.adsLoaded = false
        // }
    }

    render() {
        return this.state.goAhead ? <React.Fragment>
            {/* <div id="wrapfabtest">
                <div class="adBanner">
                </div>
            </div> */}
            <Routes />
        </React.Fragment> : null;

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        transFetchData: () => dispatch(transFetchData()),
        constraintsFetchData: () => dispatch(constraintsFetchData()),
    };
};
export default connect(null, mapDispatchToProps)(Wrapper);


// WEBPACK FOOTER //
// ./src/components/Wrapper.js